import { Password } from '@mui/icons-material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import * as Yup from 'yup';


import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginFn } from 'Services/Auth';
import InputBox from 'Shared/InputBox';

const DesktopLogin = ({

}) => {

    const navigate = useNavigate();
    const { mutate: login } = useMutation(LoginFn, {
        onSuccess: (response) => {
            const { token, user_type } = response.data.data;
            localStorage.setItem("token", token);
            localStorage.setItem("role", user_type)
            toast.success(response.data.message);
            navigate("/", { replace: true });
        }
    })

    const initialValues = {
        username: "",
        password: ""
    }


    const loginSchema = Yup.object({
        username: Yup.string().email("Email is not valid").required("Email is required"),
        password: Yup.string().required("Password is required."),
    })


    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: loginSchema,
        onSubmit: (values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => formData.append(key, values[key]));
            login(formData);
        }
    })


    return (
        <section className="w-full h-screen grid place-content-center bg-orange-50 p-4">
            <form
                className="flex flex-col gap-4 border-2 border-orange-500 rounded-lg p-6 shadow-xl shadow-orange-100 bg-white max-w-[400px] w-full"
                onSubmit={handleSubmit}
            >
                <p className='flex items-center justify-between'>
                    <span className='font-bold text-btn text-2xl'>Sign In</span>
                    <img src={"https://leadindia.appvedas.com/static/media/trade-india-logo.7607c93bb137d24dd4f4a13eab5d967f.svg"} alt="TradeIndia" className='h-9' />
                </p>

                <p className='text-sm'>Sign In to Get The Best Deals, Exclusive Offers with TradeIndia</p>

                <InputBox
                    icon={MailOutlineIcon}
                    name={"username"}
                    placeholder={"Email"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.username}
                    error={errors.username}
                />

                <InputBox
                    icon={Password}
                    name={"password"}
                    type="password"
                    placeholder={"Password"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.password}
                    error={errors.password}
                />

                <button
                    type="submit"
                    className="bg-gradient-to-r from-blue-400 to-blue-600 px-4 py-2 text-white rounded-md font-medium"
                >
                    Sign In
                    <ArrowRightAltIcon />
                </button>
            </form>

        </section>
    )
}

export default DesktopLogin